import React, { useEffect, useRef, useState } from 'react'

// import { TbEdit } from "react-icons/tb"; // unused now that "generate a new case estimate" is commented out below (feature on hold)
import { InfoIcon } from 'lucide-react';

// import CaseEstimateModal from 'Modals/CaseEstimateModal'; // unused now that "generate a new case estimate" is commented out below (feature on hold)
import CountUp from 'react-countup';

function AiCaseEstimate({caseDetails,
    aiResponse,
    setAiCountExpired,
    aiCountExpired,
    setUpdateComp,

}) {
     const [showAiScale, setShowAiScale] = useState(false);
    const [showInfo, setShowInfo] = useState(false);
    const formRef = useRef(null);

  return (
    <div className='flex justify-center w-full lg:mt-2 mb-6 font-plexsans'>
      {caseDetails?.aiEstimate &&
                        <div className='flex flex-col w-full items-center'>

                            <div
                              onMouseEnter={() => setShowInfo(true)}
                              onMouseLeave={() => setShowInfo(false)}
                              ref={formRef}
                              className='relative w-full rounded-[10px] bg-navy px-6 py-7 lg:py-8 flex flex-col items-center'>
                              <div className='text-[11px] tracking-[0.14em] font-semibold text-gold uppercase'>
                                AI Estimated Settlement Range
                              </div>
                              <div className="flex items-baseline gap-3 mt-2 text-white font-spectral">
                                <span className="text-[26px] lg:text-[34px] font-semibold">
                                  $<CountUp end={caseDetails?.aiEstimateLowerValue} duration={10} />
                                </span>
                                <span className="text-sm text-[rgba(255,255,255,.55)]">to</span>
                                <span className="text-[26px] lg:text-[34px] font-semibold">
                                  $<CountUp end={caseDetails?.aiEstimateUpperValue} duration={10} />
                                </span>
                              </div>
                              {showInfo &&
                              <div className='absolute z-10 bg-white w-[90%] max-w-[450px] flex items-center text-[rgba(20,33,61,.7)] p-2 rounded border -top-10 border-tan shadow-md text-xs'>
                                <InfoIcon className='w-4 h-4 mr-2 flex-none'/>  This is an AI generated estimate of the settlement for your case.
                              </div>
                              }
                            </div>

                            {/* "Generate a new case estimate" (and its daily-limit notice) is on hold per request - commented out, not removed. */}
                            {/*
                            {
                            caseDetails &&(  aiCountExpired ? <div className='text-red-600 text-xs lg:text-sm font-semibold text-center mt-3'>
                                You have reached the daily limit of {process.env.REACT_APP_AI_CHANCE_COUNT} AI Requests for the day.
                            </div>
                            :
                            <div className='text-sm w-full flex items-center justify-center text-center cursor-pointer mt-3'
                            onClick={() => {
                                setShowAiScale(true);
                            }}
                            ><span className='w-full justify-center flex border border-[rgba(20,33,61,.15)] hover:border-tan text-[rgba(20,33,61,.6)] hover:text-tan rounded-lg p-2 py-3 text-xs items-center transition-colors'><TbEdit/>&nbsp;Click here to generate a new case estimate</span></div>
                            )}
                            {showAiScale &&
                              <CaseEstimateModal
                                uploadNew={showAiScale}
                                onClose={() => setShowAiScale(false)}
                                caseDetails={caseDetails}
                                setShowAiScale={setShowAiScale}
                                setAiCountExpired={setAiCountExpired}
                                aiCountExpired={aiCountExpired}
                                setUpdateComp={setUpdateComp}
                              />
                                }
                            */}
                        </div>
                        }
    </div>
  )
}

export default AiCaseEstimate
